import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface Photo {
  id: string;
  url: string;
  filename: string;
  ai_damage_detected: boolean;
}

interface PhotoAnalysisSectionProps {
  photos: Photo[];
  onViewAll: () => void;
}

export const PhotoAnalysisSection = ({
  photos,
  onViewAll,
}: PhotoAnalysisSectionProps) => {
  const displayPhotos = photos.slice(0, 3);
  const materialsCount = photos.filter((p) => p.ai_damage_detected).length;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Photo Analysis</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-sm text-muted-foreground">
          {materialsCount} materials identified
        </div>

        {displayPhotos.length > 0 ? (
          <>
            <div className="flex gap-2 overflow-x-auto">
              {displayPhotos.map((photo) => (
                <div
                  key={photo.id}
                  className="relative flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden"
                >
                  <img
                    src={photo.url}
                    alt={photo.filename}
                    className="w-full h-full object-cover"
                  />
                  {photo.ai_damage_detected && (
                    <Badge className="absolute top-1 right-1 text-xs">
                      Damage
                    </Badge>
                  )}
                </div>
              ))}
            </div>
            <Button variant="outline" className="w-full" onClick={onViewAll}>
              View All Photos ({photos.length})
            </Button>
          </>
        ) : (
          <div className="py-8 text-center text-sm text-muted-foreground">
            No photos uploaded yet
          </div>
        )}
      </CardContent>
    </Card>
  );
};
